import { IDoOrder, IDoOrderReq, IDoOrderRes } from '@/interfaces/doOrder';

import * as baseAdapter from './baseAdapter';

export const searchDoOrders = async (req: IDoOrderReq) => {
  const ret = await baseAdapter.post<IDoOrderRes>('/doOrder/gets', req);
  return ret;
};

export const addDoOrder = async (data: Partial<IDoOrder>) => {
  const ret = await baseAdapter.post<IDoOrder>('/doOrder/create', data);
  return ret;
};

export const editDoOrder = async (data: Partial<IDoOrder>) => {
  const ret = await baseAdapter.put(`/doOrder/update/${data.id}`, data);
  return ret;
};

export const getDoOrder = async (id: number) => {
  const ret = await baseAdapter.get<IDoOrder>('/doOrder/get/' + id);
  return ret?.data;
};

export const deleteDoOrder = async (id: number) => {
  const ret = await baseAdapter.deleteRequest(`/doOrder/delete/${id}`);
  return ret;
};

export const importDoOrder = async (data: Partial<IDoOrder>[]) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const ret = await baseAdapter.post<any>(`/doOrder/import`, data);
  return ret;
};
